import { render, staticRenderFns } from "./PolicyHullRiskDetails.vue?vue&type=template&id=c38ff23c&"
import script from "./PolicyHullRiskDetails.vue?vue&type=script&lang=js&"
export * from "./PolicyHullRiskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports